import gql from 'graphql-tag';

export const CAMPAIGN_FOR_INSIGHTS_PAGE_QUERY = gql`
  query CampaignForInsightsPageQuery($id: ID!) {
    campaign(id: $id) {
      publisherId
      adInsightsLastUpdatedAt
      performanceRules {
        triggered
        status
        discardedAt
        executionSpec
        id
      }
      id
      name
      createdAt
      ccaEnabled
      storyAudienceEnable
      useCase
      campaignType
      primaryAccountTimezone
      defaultFacebookAccount {
        name
        accountId
      }
      facebookAccount {
        id
        name
        accountId
      }
      budgetOptimizationStrategy
      ccaSettings {
        automaticCreativeCreation
        automaticApprovalRequest
        automaticApprovalRequestType
        postTextHashtagsEnabled
        postTextHashtags
      }
      remainingBudget
      autoBudgetSpread
      defaultPlacementDevicePlatforms
      runnerProfile
      defaultCountries
      unifiedConversionPixel
      unifiedTrackingPixels
      excludedCustomAudiences
      utmParameters
      adMacroTags
      maxCpa
      dailyMonitorBudget
      end
      snowplowAppIds
      domains {
        id
        address
      }
      flipperFeatures {
        name
        enabled
      }
      campaignObjective
      savedAudienceId
      useSavedAudience
      configApprovalRequired
      modifiedChecklistFields
      pageLockedArticlesEnabled
      facebookPageAssignments {
        facebookPageDisplayName
        trackingParamKey
        trackingParamValue
      }
      campaignFacebookPages {
        id
        facebookPageId
        facebookPageDisplayName
      }
      campaignsGoogleConfig {
        dailyBudget
      }
      publisher {
        name
        pageLockedArticlesEnabled
        publisherFacebookAccounts {
          priority
          facebookAccount {
            name
            accountId
            businessId
          }
        }
        facebookAccounts {
          accountId
          timezone
        }
      }
    }
  }
`;

export const CAMPAIGN_QUERY = gql`
  query CampaignQuery($id: ID!) {
    campaign(id: $id) {
      start
      end
      createdAt
      campaignSpentToday {
        spentToday
      }
      storyAudienceEnable
      useCase
      dailyMonitorBudget
      budget
      goalCpa
      cpaRiskFactor
      maxCpa
      autoBudgetSpread
      campaignTotalSpent
      remainingBudget
      totalDiscountSpent
      remainingDiscountedBudget
      monthlyDiscount
      defaultPlacementDevicePlatforms
      runnerProfile
      defaultCountries
      unifiedConversionPixel
      unifiedTrackingPixels
      excludedCustomAudiences
      utmParameters
      adMacroTags
      snowplowAppIds
      configApprovalRequired
      campaignObjective
      modifiedChecklistFields
      pageLockedArticlesEnabled
      facebookPageAssignments {
        facebookPageDisplayName
        trackingParamKey
        trackingParamValue
      }
    }
  }
`;
